import {MenuItem} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import DropDown from '../../ui/drop-down.jsx';

export const ProcessColorPicker = ({
  colorMap,
  inputName = null,
  labelledby,
  onChange = () => {},
  processColor,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = e => {
    setInputValue(e.target.value);
    onChange(e);
  };

  useEffect(() => {
    setInputValue(processColor);
  }, [processColor]);

  return (
    <DropDown
      onChange={handleChange}
      value={inputValue in colorMap ? inputValue : ''}
      variant="standard"
      margin="dense"
      InputProps={{
        name: inputName,
        disableUnderline: true,
        'aria-labelledby': labelledby,
      }}
      SelectProps={{autoWidth: false, MenuProps: {sx: {maxWidth: 400}}}}
    >
      {Object.keys(colorMap).map(color => (
        <MenuItem value={color} key={color}>
          <img
            alt={color}
            height={10}
            src={colorMap[color]?.icon}
            width="100%"
            draggable="false"
          />
        </MenuItem>
      ))}
    </DropDown>
  );
};

ProcessColorPicker.propTypes = {
  colorMap: PropTypes.objectOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
    })
  ).isRequired,
  inputName: PropTypes.string,
  labelledby: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  processColor: PropTypes.string.isRequired,
};

export default ProcessColorPicker;
